import React from 'react'

import ControlButtonClose from "../../buttons/control-button/close"
import {useEntitySelectorContext} from "../context"

type Props = {
    title   : string    // the entity type being picked -- the sidebar's own heading is the host's
}

// The content column's own title line -- the entity type being picked, plus the
// host's close control.
//
// Rendered only by a host that has chrome (see `EntitySelector`): the mention
// popover has no title and dismisses on an outside click, so it drops this row
// entirely rather than showing a bare label over a dead "x".  The close stays
// optional so a titled host can still go without one.
//
// `entity-selector-header` is the SAME box the sidebar heading uses -- both
// titles have to land on one line.
export default function EntitySelectorContentHeader(props: Props) {
    const context = useEntitySelectorContext()

    const classes = Classes("entity-selector-header flex-row-left-center fl-sb flex-no-shrink", {
        'with-close': !!context.onClose
    })

    return (
        <div className={classes}>
            <div className="ui5-title-app-name txt-truncate">{props.title}</div>

            {!!context.onClose &&
                <ControlButtonClose onClick={context.onClose}/>
            }
        </div>
    )
}
